<form>
    <input
        #autocomplete
        type="text"
        class="form-element"
        placeholder="{{consts.PLACEHOLDER_SEARCH}}"
        matInput
        autocomplete="off"
        (input)="searchLinks()"
        [matAutocomplete]="auto"
        [formControl]="searchValue"
    >
    <mat-icon
        class="dropdown-arrow"
        (click)="$event.stopPropagation(); togglePanel()"
        svgIcon="hub_keyboard_arrow_down"
    >
    </mat-icon>
    <mat-autocomplete
        #auto="matAutocomplete"
        class="dd-resource-list"
        [displayWith]="getOptionText"
        (optionSelected)="updateMySelection($event.option.value)"
        required
    >
        <mat-option
            *ngFor="let option of resourceList$ | async"
            [value]="option"
        >
            {{option.name}}
        </mat-option>
    </mat-autocomplete>
</form>
